export var version = '3.4.16';
//# sourceMappingURL=version.js.map